import axios from 'axios'
import '../../assets/css/global.css'
import '../../axios/axios.config'
export function isExistFile(hash){
  return axios({
    url: '/file/'+hash,
    method: 'get',
  })
}
export function uploadFile(data){
  return axios({
    url: 'file/upload',
    method: 'post',
    data:data
  })
}
export function mergeFile(data){
  return axios({
    url: 'file/merge',
    method: 'post',
    data:data
  })
}

